import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "../apis/ApiSlice";
import ticketsReducer from "../Slices/ticketsSlice";
import eventsReducer from "../Slices/eventsSlice";
import usersReducer from "../Slices/userSlice";
import rafflesReducer from "../Slices/rafflesSlice";
import inviteLinkReducer from "../Slices/inviteLinkSlice";
import eventIdReducer from "../Slices/eventIdSlice";
import ticketCategory from "../Slices/ticketCategorySlice";
import selectedTemplate from "../Slices/selectedTemplateSlice";
import eventInfoReducer from "../Slices/eventInfoSlice";
import editEventInfoReducer from "../Slices/editEventInfoSlice";
import ticketPayloadSlice from "../Slices/ticketPayloadSlice";
import registerverificationSlice from "../Slices/registerverificationSlice";
import editTicketSlice from "../Slices/editTicketSlice";
import stripeFee from "../Slices/stripeFee";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    tickets: ticketsReducer,
    events: eventsReducer,
    users: usersReducer,
    raffles: rafflesReducer,
    inviteLink: inviteLinkReducer,
    eventId: eventIdReducer,
    ticketCategory: ticketCategory,
    selectedTemplate: selectedTemplate,
    eventInfo: eventInfoReducer,
    editEventInfo: editEventInfoReducer,
    ticketPayload: ticketPayloadSlice,
    verification: registerverificationSlice,
    editTicket: editTicketSlice,
    stripeFee: stripeFee,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

setupListeners(store.dispatch);

export default store;
